module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0180.jpg?v=e4ea2ae3";